// @flow

import { map } from 'lodash';
import { damageCnUnblockAndRtoDashboardActions } from './damageCnUnblockAndRtoDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: [],
  dashboardDataFiltered: [],
  error: null
};

const filterDashboardTableData = (newState, searchStr) => {
  const searchString = searchStr.trim();

  let filteredArr;

  if (searchString) {
    filteredArr = newState.dashboardData.filter(
      row =>
        (row.cnote &&
          row.cnote.toString() &&
          row.cnote.toString().indexOf(searchString) >= 0) ||
        (row.fromLocation &&
          row.fromLocation.toString() &&
          row.fromLocation
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.toLocation &&
          row.toLocation.toString() &&
          row.toLocation
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.reason &&
          row.reason.toString() &&
          row.reason
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0)
    );
  } else {
    filteredArr = newState.dashboardData;
  }

  return filteredArr;
};

const damageCnUnblockAndRtoDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case damageCnUnblockAndRtoDashboardActions.GET_DASHBOARD_DATA: {
      const uniqueDashboardData = Array.from(
        new Set(action.payload.dashboardData.map(data => data.cnote))
      ).map(cnote =>
        action.payload.dashboardData.find(data => data.cnote === cnote)
      );

      return {
        ...state, // Spread the existing state
        dashboardData: uniqueDashboardData, // Update only dashboardData
        dashboardDataFiltered: uniqueDashboardData,
        isLoading: false, // Assuming you want to stop loading
        isLoaded: true // Assuming the data is loaded
      };
    }
    case damageCnUnblockAndRtoDashboardActions.FILTER_DASHBOARD_DATA: {
      const newState = { ...state };
      const filtered = filterDashboardTableData(newState, action.payload);
      return {
        ...state,
        dashboardDataFiltered: filtered
      };
    }
    default: {
      return state;
    }
  }
};

export default damageCnUnblockAndRtoDashboardReducer;
